<template>
	<div class="timeline-block">
		<el-timeline>
			<el-timeline-item v-for="(item,index) in timeline" :key="index" :timestamp="item.timestamp" placement="top" type="primary">
				<el-card>
					<div class="event" v-for="(item,index) in item.event" :key="index">
						<h4>{{item.month}}</h4>
						<p v-for="(item,index) in item.content" :key="index">{{item}}</p>
					</div>
				</el-card>
			</el-timeline-item>
		</el-timeline>
	</div>
</template>

<script>
	export default {
		name: 'Progress',
		components: {},
		data() {
			return {
				timeline: [{
          			id: 2024,
					timestamp: '2024年',
					event: [{
						month: '4月',
						content: ['MoPaaS 魔泊云获得吴文俊人工智能科学技术科技进步奖']
					},{
						month: '8月',
						content: ['MoPaaS 入驻上海昇思生态创新中心，共绘人工智能璀璨新画卷']
					},{
						month: '9月',
						content: ['合作中国人工智能学会，共同主办2024第二届人工智能大模型技术高峰论坛《大模型AI应用技术和工程专题论坛》']
					}]
				},{
          			id: 2023,
					timestamp: '2023年',
					event: [{
						month: '6月',
						content: ['MoPaaS 魔泊云首批入驻上海昇思AI框架&大模型创新中心']
					}]
				},{
          			id: 2022,
					timestamp: '2022年',
					event: [{
						month: '10月',
						content: ['昇腾AI创新大赛 上海&浙江赛区 银奖']
					}]
				},{
					id: 2021,
					timestamp: '2021年',
					event: [{
						month: '6月',
						content: ['加入腾讯云原生加速器加入腾讯云原生加速器']
					}, {
						month: '10月',
						content: ['鲲鹏应用创新大赛MoPaaS AI平台 荣获“优秀解决方案”']
					}]
				},{
					id: 2020,
					timestamp: '2020年',
					event: [{
						month: '1月',
						content: ['上海张江国际人工智能挑战赛进入半决赛']
					}]
				}, {
					id: 2019,
					timestamp: '2019年',
					event: [{
						month: '10月',
						content: ['成功入选VMware创新网络(VIN) “威睿加速计划”']
					}, {
						month: '12月',
						content: ['成功入选微软云Co-sell联合销售计划']
					}]
				}, {
					id: 2018,
					timestamp: '2018年',
					event: [{
						month: '3月',
						content: ['发布 MoPaaS 人工智能技术服务平台，并落地清华大学 iCenter']
					},{
						month: '4月',
						content: ['获得中国发明专利：一个智能化 PaaS 平台系统，这个也是中国首个 含PaaS关键字的发明专利','资助主办第一届“MoPaaS杯清华大学人工智能挑战赛”']
					}, {
						month: '5月',
						content: ['MoPaaS 获选 GMIC 北京峰会 G-Startup 10 强创新企业','MoPaaS 获选参加英国皇家“龙门创将”创新创业中国区大赛']
					}, {
						month: '6月',
						content: ['赞助主办第八届中国开源云计算黑客松大赛 PaaS 部分']
					}, {
						month: '7月',
						content: ['获得2018“创客中国”智慧工厂创新创业大赛十强企业']
					}]
				}, {
					id: 2017,
					timestamp: '2017年',
					event: [{
						month: '3月',
						content: ['成功入选第九期微软加速器成员，成为微软Azure 的深度合作伙伴']
					}, {
						month: '4月',
						content: ['获得中国金融交易技术大会金融行业PaaS 平台最佳解决方案奖']
					}, {
						month: '9月',
						content: ['获得第五届全球云计算大会中国领先品牌奖']
					}]
				}, {
					id: 2016,
					timestamp: '2016年',
					event: [{
							month: '1月',
							content: ['成为阿里云合计划中唯一的 PaaS 和容器云服务深度合作伙伴']
						}, {
							month: '9月',
							content: ['参展 CloudConnect-China，MoPaaS 企业版获得全球创新产品云鼎奖']
						}, {
							month: '10月',
							content: ['MoPaaS 获得 B轮融资，投资方：Walden(开物)/马力等投资']
						}
					]
				}, {
					id: 2015,
					timestamp: '2015年',
					event: [{
							month: '2月',
							content: ['MoPaaS 企业版本正式发布']
						}, {
							month: '9月',
							content: ['参展 CloudConnect-China：获最具发展潜力的云计算公司云鼎奖']
						},
						{
							month: '12月',
							content: ['被 Forrester 评为中国企业云计算市场 Strong Performer']
						}
					]
				},{
					id: 2014,
					timestamp: '2014年',
					event: [{
							month: '6月',
							content: ['获得首个企业私有云平台订单']
						},
						{
							month: '12月',
							content: ['获得 A轮融资，投资方：马力创投、Incubic 和艾然鼎泰',
								'成为 Cloud Foundry 基金会创始会员，也是中国首个会员'
							]
						}
					]
				},{
					id: 2013,
					timestamp: '2013年',
					event: [{
						month: '2月',
						content: ['MoPaaS 核心技术专利申请。中科院查新结论：技术达到国内领先水平']
					}, {
						month: '6月',
						content: ['正式提供公有云 PaaS', '获得中国云计算大会十大云创新企业称号']
					}]
				},{
					id: 2012,
					timestamp: '2012年',
					event: [{
						month: '12月',
						content: ['MoPaaS基于开源的Cloud Foundry 云平台技术打造中国首个开放的公有云PaaS服务，并正式上线公测','赞助主办第八届中国开源云计算黑客松大赛 PaaS 部分']
					}]
				}]
			}
		}
	}
</script>

<style>
	@media(min-width:992px) {
		.timeline-block {
			width: 100%;
			border: 1px solid #ebebeb;
			border-radius: 3px;
			transition: .2s;
			padding: 20px 60px;
		}

		.timeline-block .el-timeline-item__timestamp {
			font-size: 18px;
			text-align: left;
			font-weight: 400;
			font-family: "microsoft yahei";
		}

		.timeline-block h4 {
			font-weight: 500;
			color: #1f2f3d;
			font-family: "microsoft yahei";
			font-size: 14px;
			text-align: left;
			margin: 18.62px 0;
		}

		.timeline-block p {
			displxay: inline-block;
			font-family: "microsoft yahei";
			font-size: 14px;
			color: #5e6d82;
			line-height: 1.5;
			text-align: left;
		}
	}

	@media(max-width:992px) {
		.timeline-block .el-timeline-item__timestamp {
			font-size: 18px;
			text-align: left;
			font-weight: 400;
			font-family: "microsoft yahei";
		}

		.timeline-block h4 {
			font-weight: 500;
			color: #1f2f3d;
			font-family: "microsoft yahei";
			font-size: 14px;
			text-align: left;
			margin: 18.62px 0;
		}

		.timeline-block p {
			displxay: inline-block;
			font-family: "microsoft yahei";
			font-size: 14px;
			color: #5e6d82;
			line-height: 1.5;
			text-align: left;
		}
	}
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/Progress.vue